<!-- TODO: REVERT - This file was originally a Calendly embed (appointment-calendly.vue). See git history to restore original Calendly version. -->
<template>
	<Modal
		:allow-close="false"
		:prevent-scrolling="false"
		:max-width="'max-w-[600px]'"
	>
		<template #body>
			<div class="flex flex-col items-center py-6">
				<div class="flex flex-col justify-start">
					<p class="text-left font-[Inter] text-[17px] font-semibold text-won-ash-gray">
						Before you get started with WonsultingAI...
					</p>
					<p class="mt-4 text-left font-[Inter] text-2xl font-semibold text-won-green">
						Need extra help on your job search?
					</p>
					<p class="mt-6 text-left font-[Inter] text-[17px] font-normal text-won-ash-gray">
						Job searching on your own can be exhausting - let us do the work for you. Land a job in 120 days or your money back, guaranteed.
					</p>
				</div>

				<div class="mt-6 flex w-full gap-3">
					<button
						:class="[ghostButtonStyle]"
						class="w-auto! flex-1"
						@click="handleClose"
					>No thanks</button>
					<button
						:class="[buttonStyle]"
						class="w-auto! flex-1"
						@click="handleBookCall"
					>Book a free call with us</button>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import Modal from '../components/modal.vue';
import { ghostButtonStyle, buttonStyle } from '../utils/styles';
import { TYPEFORM_SALES_UTM_URL } from '../utils/constants';
import { openLink } from '../utils/helpers';

const emit = defineEmits(['close', 'submitted']);

const handleClose = () => {
	emit('close');
};

const handleBookCall = () => {
	openLink(TYPEFORM_SALES_UTM_URL, true);
	emit('close');
};
</script>
